import dayjs from "dayjs";

function goToFirstError(className = 'error-check') {
    const error = document.getElementsByClassName(className);

    for (let i in error) {
        if (error[i].style && error[i].style.display !== 'none') {
            if ($(error[i]).parent().length) {
                $('html, body').animate({
                    scrollTop: $(error[i]).parent().offset().top - 75
                }, 750);
            }
            break;
        }
    }
}

function onlyAlphaNumeric(val) {
    var re = /^[\x00-\x7F]+$/;
    if (val) {
        val = val.toString();
        return re.test(val.toLowerCase()) && /^([^()'<>]+)$/.test(val.toLowerCase());
    } else {
        return true;
    }
}

function monthDate(val) {
  var flag = true;
  var lang = window.globalLanguage.lang;
  var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

  var year;

  if(val) {
    val = val.trim();
    var dateArray = (lang == "zh" || lang == 'ja' || lang == 'ko') ? val.split("-") : val.split("/");
    var yearLength;
    if(Array.isArray(dateArray)) {
      if(lang == "zh" || lang == 'ja' || lang == 'ko') {
        yearLength = dateArray[0].length;
      }  else {
        yearLength = dateArray[2] ? dateArray[2].length : '';
      }
    }

    if(dateArray.length == 3 && yearLength === 4) {
      let month,day,monthStr,dayStr;

      if(lang == "en" || lang == 'it' || lang == 'ru') {
        month = parseInt(Number(dateArray[0]));
        day = parseInt(Number(dateArray[1]));
        year = Number(dateArray[2]);
        monthStr = dateArray[0];
        dayStr = dateArray[1];
      }
      if(lang == "es" || lang == "ar") {
        day = parseInt(Number(dateArray[0]));
        month = parseInt(Number(dateArray[1]));
        year = Number(dateArray[2]);
        monthStr = dateArray[1];
        dayStr = dateArray[0];
      }
      if(lang == "zh" || lang == 'ja' || lang == 'ko') {
        day = parseInt(Number(dateArray[2]));
        month = parseInt(Number(dateArray[1]));
        year = Number(dateArray[0]);
        monthStr = dateArray[1];
        dayStr = dateArray[2];
      }
      // Adjust for leap years
      if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) monthLength[1] = 29;
      if(month > 0 && month <= 12 && day > 0 && day <= monthLength[month - 1]) flag = true;
      else flag = false;

      // check for the month and day length to be less than 3

      if(dayStr && dayStr.length > 2 || monthStr && monthStr.length > 2) flag = false;

      if(flag && isNaN(year)) flag = false;

      if(year < 1000 || month == 0 || month > 12) return false;

    } else flag = false;

  }
  return flag;
}

function travelDateValidation(val) {
    var split = ' to ';
    var regx = /^\d{2}\/\d{2}\/\d{4}\sto\s\d{2}\/\d{2}\/\d{4}$/g;
    if(window.globalLanguage && window.globalLanguage.lang === 'es') {
        regx = /^\d{2}\/\d{2}\/\d{4}\shasta\s\d{2}\/\d{2}\/\d{4}$/g;
        split = ' hasta ';
    } else if(window.globalLanguage && window.globalLanguage.lang === 'zh') {
        regx = /^\d{4}-\d{2}-\d{2}\s到\s\d{4}-\d{2}-\d{2}$/g;
        split = ' 到 ';
    }
    if (val) {
        let isRexValid = regx.test(val);
        let datesvalid = true;
        if (isRexValid) {
            const dates = val.split(split);
            for (let i = 0; i < dates.length; i++) {
                const element = dates[i];
                datesvalid = monthDate(element);
                if (!datesvalid) {
                    break;
                }
            }
        }
        return isRexValid && datesvalid;
    } else {
        return true;
    }

}

function isPasswordValid(val) {
    var regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).*$/g;
    if (val) {
        return regx.test(val) && val.length > 7;
    } else {
        return true;
    }
}

function currentPage() {     
     return window.bnJS.currentPage;
}

function findCountry(newCode, isTwoLetter) {
    let countries = window.bnJS.countries || [];
    let countrySelected, 
        i = 0,
        cLength = countries.length,
        country;
    if (cLength) {
        for (i; i < cLength; i++) {
            country = countries[i];
            if(country.newCode === newCode) {
                countrySelected = country.name;
                break;
            }
        }
    }
    return countrySelected;
}

function setItemSessionStorage(key, value) {
    try {
        if (value) {
            window.sessionStorage.setItem(key, value);
        }
    } catch (e) {
        console.log("Session Storage is not enabled.");
    }
}

function getItemSessionStorage(key) {
    try {
        if (window.sessionStorage[key] !== undefined) {
            return window.sessionStorage.getItem(key);
        } else {
            return undefined;
        }
    } catch (e) {
        return undefined;
    }
}

function dateNotInFuture(val) {
    let val1, val2;
    let seperator = window.globalLanguage.datePicker.to;
    if(val && window.globalLanguage){
        if(val.indexOf(seperator) > -1) {            
            val1 = val.split(seperator)[0].trim();
            val2 = val.split(seperator)[1].trim();
            var dateToCheck1 = createDateByLangStr(val1);
            var dateToCheck2 = createDateByLangStr(val2);
            var today = new Date();
    
            return today.setHours(0,0,0,0) >= dateToCheck2.setHours(0,0,0,0) && today.setHours(0,0,0,0) >= dateToCheck1.setHours(0,0,0,0);
        } else {
            return false;
        }
    }
    else{
        return true;
    }
}

function dateNotBefore(date) {
    return function (val) {
        let val1, val2;
        let seperator = window.globalLanguage.datePicker.to;
        if(val && window.globalLanguage){
            if(val.indexOf(seperator) > -1) {            
                val1 = val.split(seperator)[0].trim();
                val2 = val.split(seperator)[1].trim();
                var dateToCheck1 = createDateByLangStr(val1);
                var dateToCheck2 = createDateByLangStr(val2);
                var dateToValidate = new Date(date);
        
                return dateToValidate.setHours(0,0,0,0) <= dateToCheck2.setHours(0,0,0,0) && dateToValidate.setHours(0,0,0,0) <= dateToCheck1.setHours(0,0,0,0);
            } else {
                return false;
            }
        }
        else{
            return true;
        }
    }
}

function createDateByLangStr(string, language) {
  var lang = language || window.globalLanguage.lang;  
  if (lang === 'en') {
    let date = string.split('/');
    date = new Date(date[2], date[0] - 1, date[1]);
    return date;
  }
  if (lang === 'es') {
    let date = string.split('/');
    date = new Date(date[2], date[1] - 1, date[0]);
    return date;
  }
  if (lang === 'zh') {
    let date = string.split('-');
    if(date instanceof Array && date.length < 3){
       date = string.split('/');
    }
    date = new Date(date[0], date[1] - 1, date[2]);
    return date;
  }
}

function getDateFromLanguage(dateInp, language = window.globalLanguage.lang) {
    let formatDate;
    let d = new Date(dateInp); // this wil be affected by TimeZone
    let month = d.getMonth() + 1;
    let date = d.getDate();

    if (month < 10) {
        month = "0" + month;
    }
    if (date < 10) {
        date = "0" + date;
    }

    if (language === 'zh') {
        formatDate = d.getFullYear() + '-' + month + '-' + date;
    } else if (language === 'es') {
        formatDate = date + '/' + month + '/' + d.getFullYear();
    } else if (language === 'en') {
        return month + '/' + date + '/' + d.getFullYear();
    }

    return formatDate;
}

function removeKeySessionStorage(key) {
    try {
        window.sessionStorage.removeItem(key);
    } catch(e) {
        console.log("Enable Cache.");
    }
}

function setLocalStorage(key, value) {
    try {
        if(key && value) {
            window.localStorage.setItem(key, value)
        }
    } catch(e) {
        console.log('Please enable cookie.')
    }
}

function readFromLocalStorage(key) {
    try {
        if(key) {
            return window.localStorage.getItem(key);
        }
        return null;
    } catch (e) {
        return null;
    }
}

function deleteItemInLocalStorage(key) {
    try {
        if(key) {
            window.localStorage.removeItem(key);
        }
    } catch (e) {
        console.log('Please enable cookie.');
    }
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

let dateRangeCustomShrts = [
    {
        name: window.globalLanguage.datePicker.today,
        dates: function () {
            //move calendars to show this date's month and next month
            var movetodate = dayjs().toDate();
            return [movetodate, movetodate];
        }
    },
    {
        name: window.globalLanguage.datePicker.yesterday,
        dates: function () {
            //move calendars to show this date's month and next month
            var movetodate = dayjs().subtract(1, 'day')._d;
            return [movetodate, movetodate];
        }
    },
    {
        name: window.bnJS.isActivityReport ? window.globalLanguage.datePicker.priorWeek : window.globalLanguage.datePicker.thisWeek,
        dates: function () {
            var start = null;
            var end = null;
            
            if (window.bnJS.isActivityReport) {
                let startSun = dayjs().subtract(1, 'week').startOf('week');
                start = startSun.subtract(1, 'day').$d;
                let endSat = dayjs().subtract(1, 'week').endOf('week');
                end = endSat.subtract(1, 'day').$d
            } else {
                start = dayjs().day(0).toDate();
                end = dayjs().subtract(1, 'day').$d;
            }
            return [start, end];
        }
    },
    {
        name: window.globalLanguage.datePicker.monthToDate,
        dates: function () {
            const todaysDate = dayjs().get('date');
            var start = dayjs().startOf('month').$d;
            var end = dayjs().subtract(1, 'day').$d;
            if (todaysDate === 1) {
                start = dayjs().subtract(1,'month').startOf('month').$d;
                end = dayjs().subtract(1,'month').endOf('month').$d;
            }
            return [start, end];
        }
    },
    {
        name: window.globalLanguage.datePicker.yearToDate,
        dates: function () {
            var todayDate = new Date();
            var start = dayjs().startOf('year').$d;
            var end = dayjs().subtract(1, 'day').$d;
            return [start, end];
        }
    }, {
        name: window.globalLanguage.datePicker.ttm,
        dates: function () {
            var todayDate = new Date();
            var start = dayjs().subtract(12, 'months').$d;
            var end = dayjs().subtract(1, 'day').$d;
            return [start, end];
        }
    }
];

export {
    goToFirstError,
    onlyAlphaNumeric,
    travelDateValidation,
    dateNotInFuture,
    createDateByLangStr,
    isPasswordValid,
    currentPage,
    findCountry,
    setItemSessionStorage,
    getItemSessionStorage,
    removeKeySessionStorage,
    setLocalStorage,
    readFromLocalStorage,
    deleteItemInLocalStorage,
    getDateFromLanguage,
    dateNotBefore,
    dateRangeCustomShrts,
    getParameterByName
}